import { PromptInput, PromptInputSubmit, PromptInputTextarea } from '@cobliteam/ai/src/components/elements/PromptInput';
import Alert from '@cobliteam/ui/components/Alert';
import type { ChatStatus, UIMessage } from 'ai';
import { memo, useCallback, useState } from 'react';

interface AgentChatInputProps {
  sendMessage: (message: UIMessage) => Promise<void>;
  status: ChatStatus;
  stop: () => void;
}

const AgentChatInput = ({ sendMessage, status, stop }: AgentChatInputProps) => {
  const [input, setInput] = useState('');

  const handleSubmit = useCallback(
    async (e: React.FormEvent) => {
      e.preventDefault();

      if (status !== 'ready') {
        stop();
        return;
      }

      const trimmedInput = input.trim();
      if (!trimmedInput) {
        Alert.error('Digite uma mensagem');
        return;
      }

      try {
        await sendMessage({ role: 'user', id: crypto.randomUUID(), parts: [{ type: 'text', text: trimmedInput }] });
        setInput('');
      } catch {
        Alert.error('Erro ao enviar mensagem');
      }
    },
    [input, status, sendMessage, stop]
  );

  return (
    <div className='border-t p-3'>
      <PromptInput onSubmit={handleSubmit} className='relative bg-white'>
        <PromptInputTextarea placeholder='Digite sua mensagem...' value={input} onChange={(e) => setInput(e.target.value)} disabled={status !== 'ready'} />
        <PromptInputSubmit disabled={status === 'ready' && !input} status={status} className='absolute right-2.5 bottom-2.5' />
      </PromptInput>
    </div>
  );
};

export default memo(AgentChatInput);
